import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { ChangeLogoModal } from 'src/modules/features/admin/modals';
import {
  ModalSize,
  SuiModalService,
  ModalTemplate,
  TemplateModalConfig,
} from '@richardlt/ng2-semantic-ui';
import {
  AvaliableChangeModal,
  MyProfileModal,
  UsernameChangeModal,
} from '../../modals';
import { AccountService } from '../../services';
import { AuthenticationService } from 'src/modules/core/services';
import { CommonServices } from 'src/modules/shared';
import { environment } from 'src/environments/environment';
import {
  CropperSettings,
  ImageCropperComponent,
  Bounds,
} from 'ngx-img-cropper';
@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss'],
})
export class MyProfileComponent implements OnInit {
  @ViewChild('cropper') cropper: ImageCropperComponent;
  @ViewChild('uploadTemplate') public modalTemplate: ModalTemplate<
    any,
    string,
    string
  >;
  user: any;
  organization: any;
  pending: boolean;
  error: any;
  success: any;
  image = 'assets/avatar/1.jpg';
  baseUrl: string = environment.API_SERVER;
  cropperSettings: CropperSettings;
  mode = 'date';
  data = { image: 'assets/avatar/1.jpg' };
  file: any;
  constructor(
    private authService: AuthenticationService,
    private modalService: SuiModalService,
    private location: Location,
    private accountSvc: AccountService
  ) {
    this.authService.user.subscribe((res) => {
      this.user = res;
      if (this.user && this.user.image) {
        this.image = `${
          this.baseUrl
        }/public/image/?media=${this.convertBackslashesToForwardSlashes(
          this.user.image
        )}`;
        this.data = {
          image: `${this.baseUrl}/public/image/?media=${this.user.image.replace(
            /\\/g,
            '/'
          )}`,
        };
      }
      this.cropperSettings = new CropperSettings();
      this.cropperSettings.noFileInput = true;
      this.cropperSettings.width = 380;
      this.cropperSettings.height = 300;

      this.cropperSettings.croppedWidth = 190;
      this.cropperSettings.croppedHeight = 150;

      this.cropperSettings.canvasWidth = 240;
      this.cropperSettings.canvasHeight = 140;
    });
    this.getUserAvailiablity();
  }
  convertBackslashesToForwardSlashes(url) {
    return url.replace(/\\/g, '/');
  }

  popModal() {
    const config = new TemplateModalConfig<any, string, string>(
      this.modalTemplate
    );
    config.isClosable = false;
    config.transitionDuration = 200;
    config.transition = 'slide left';
    config.size = ModalSize.Tiny;
    config.isFullScreen = false;
    config.isInverted = false;
    this.modalService
      .open(config)
      .onApprove((result) => {
        this.uploadImage(this.data.image);
      })
      .onDeny((result) => {
        /* deny callback */
      });
  }

  fileChangeListener($event) {
    // console.log($event)
    const image: any = new Image();
    this.file = $event.target.files[0];
    const file: File = $event.target.files[0];
    const myReader: FileReader = new FileReader();
    const that = this;
    myReader.onloadend = (loadEvent: any) => {
      image.src = loadEvent.target.result;
      that.cropper.setImage(image);
    };
    myReader.readAsDataURL(file);
    // that.imageDone.emit(this.data.image)
  }

  uploadImage(event) {
    this.pending = true;
    this.error = false;
    const formData = new FormData();
    formData.append('file', this.file);
    this.accountSvc
      .uploadUserPhoto({ appUserId: this.user.appUserId, body: formData })
      .subscribe(
        (res) => {
          this.image = `${this.baseUrl}/public/image/?media=${res[
            'data'
          ].replace(/\\/g, '/')}`;
          this.user.image = res['data'].replace(/\\/g, '/');
          window.localStorage.setItem(
            'user',
            JSON.stringify(Object.assign({}, this.user))
          );
          this.authService.setRefreshStorage(res);
          setTimeout(() => {
            this.pending = false;
            this.success = 'Profile updated successfully';
          }, 1000);
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error.error
            ? error.error.error
            : error.error
            ? error.error
            : error;
        }
      );
  }
  changeImage() {
    this.modalService
      .open(new ChangeLogoModal('Edit Logo', this.user, ModalSize.Tiny))
      .onApprove((file: any) => {
        function getBase64(file) {
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = function () {
            console.log(reader.result);
          };
          reader.onerror = function (error) {
            console.log('Error: ', error);
          };
        }
        // let payload = getBase64(file);
        this.pending = true;
        const formData = new FormData();
        formData.append('file', file);
        this.accountSvc
          .uploadUserPhoto({ appUserId: this.user.appUserId, body: formData })
          .subscribe(
            (res) => {
              this.pending = false;
              this.success = 'Profile updated successfully';
              this.image = `${this.baseUrl}/public/image/?media=${res[
                'data'
              ].replace(/\\/g, '/')}`;
              this.user.image = res['data'].replace(/\\/g, '/');
              window.localStorage.setItem(
                'user',
                JSON.stringify(Object.assign({}, this.user))
              );
              this.authService.setRefreshStorage(res);
              window.location.reload();
            },
            (error) => {
              this.pending = false;
              this.error = error.error.errorMessage
                ? error.error.errorMessage
                : error.error
                ? error.error
                : error;
            }
          );
      })
      .onDeny(() => {});
  }
  userAvailiable;
  getUserAvailiablity() {
    this.pending = true;
    this.error = false;
    this.accountSvc
      .getUserAvailiability({ appUserId: this.user.appUserId })
      .subscribe(
        (res) => {
          this.userAvailiable = res;
          this.pending = false;
        },
        (error) => {
          this.pending = false;
          this.error = error.error;
        }
      );
  }
  edit() {
    this.modalService
      .open(
        new MyProfileModal('Edit My Profile', this.user, true, ModalSize.Tiny)
      )
      .onApprove((updated: any) => {
        this.user = { ...this.user, ...updated };
        window.localStorage.setItem(
          'user',
          JSON.stringify(Object.assign({}, this.user))
        );
        this.authService.setRefreshStorage('');
      })
      .onDeny(() => {});
  }
  username(isUsername) {
    this.modalService
      .open(
        new UsernameChangeModal(
          'Edit My Profile',
          this.user,
          isUsername,
          ModalSize.Tiny
        )
      )
      .onApprove((updated: any) => {
        console.log({ updated });
        if (isUsername) {
          this.user = {
            ...this.user,
            ...{ username: updated.usernameOrEmail },
          };
        } else {
          this.user = {
            ...this.user,
            ...{ appUserEmail: updated.usernameOrEmail },
          };
        }
        window.localStorage.setItem(
          'user',
          JSON.stringify(Object.assign({}, this.user))
        );
        this.authService.setRefreshStorage('');
      })
      .onDeny(() => {});
  }
  availiable(isAvailable) {
    this.modalService
      .open(
        new AvaliableChangeModal(
          'Edit My Profile',
          this.user,
          isAvailable,
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.getUserAvailiablity();
        this.authService.setRefreshStorage('');
      })
      .onDeny(() => {});
  }
  goBack() {
    this.location.back();
  }
  ngOnInit(): void {}
  editUsername() {}
  editEmail() {}
}
